import { Component } from '@angular/core';
import { slideInAndOut } from '../../../@vex/animations/fade-out-up.animation';

@Component({
	selector: 'app-splash-screen',
	template: `
		<div class="background" @slideInAndOut>
			<div class="glass"></div>
			<app-spinner></app-spinner>
		</div>
	`,
	styles: [
		`
			.background {
				background-image: url('/assets/img/splash-background.jpeg');
				background-position: center center;
				background-repeat: no-repeat;
				background-size: cover;
				margin: 0;
				height: 100%;
				width: 100%;
			}

			.glass {
				margin: 0;
				height: 100%;
				width: 100%;
				/*background-color: rgba(255, 255, 255, 0.5);
          -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
          box-shadow: inset 0 0 0 200px rgba(255,255,255,0.08);*/

				-webkit-backdrop-filter: blur(8px); /* Safari 9+ */
				backdrop-filter: blur(8px); /* Chrome and Opera */
				/*box-shadow: 0px 10px 15px 10px rgb(0 0 0 / 15%);
				background-color: rgb(228 228 228 / 15%);*/
			}
		`,
	],
	animations: [slideInAndOut],
})
export class SplashScreenComponent {
	windowWidth: string;
	splashTransition: string;
	opacityChange: number = 1;
	showSplash = true;
	constructor() {}
}
